import PropTypes from 'prop-types';

const TableRowAction = {
  icon: PropTypes.string,
  onClick: PropTypes.func,
  render: PropTypes.func,
};

export const TableRowActionShape = PropTypes.shape(TableRowAction);
export const TableRowActionExact = PropTypes.exact(TableRowAction);
